import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Courses from "../../components/homeSegments/Courses";
import Review from "../../components/homeSegments/Review";
import SearchedCard from "../../components/homeSegments/SearchedCard";
import Slider from "../../components/homeSegments/Slider";
import Demos from "../../components/homeSegments/demos";
import CustomLoader from "../../components/loader/loader";
import SubDomainRouter from "../../components/subDomainRouter/subDomainRouter";
import * as Actions from "../../constants/baseUrl";
import "./home.css";

const Home = () => {
  const [itemSearched, setItemSearched] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const populateList = async () => {
    setLoading(true);
    if (searchQuery.trim() === "") {
      return null;
    }

    try {
      await axios
        .get(`${Actions.BASE_URL}search/${searchQuery}`)
        .then((response) => {
          setItemSearched(response.data);
          setLoading(false);
        });
    } catch (error) {
      setLoading(false);
      console.log("There was an error", error);
    }
  };

  useEffect(() => {
    populateList();
  }, [searchQuery]);

  const siteName = SubDomainRouter("title");
  const demosNavItem = SubDomainRouter("demosNavItem");
  const coursesNavItem = SubDomainRouter("coursesNavItem");
  const reviewsNavItem = SubDomainRouter("reviewsNavItem");
  return (
    <>
      <Helmet>
        <title>
          {siteName
            ? siteName
            : "Ameerpet IT - World's Biggest Live Instructors Marketplace"}
        </title>
      </Helmet>

      <Slider setSearchQuery={setSearchQuery} searchQuery={searchQuery} />
      {searchQuery === "" ? (
        <>
          {demosNavItem && demosNavItem === "show" && <Demos />}
          {coursesNavItem && coursesNavItem === "show" && <Courses />}
          {reviewsNavItem && reviewsNavItem === "show" && <Review />}
        </>
      ) : (
        <>
          {loading ? (
            <CustomLoader />
          ) : (
            <SearchedCard itemSearched={itemSearched} />
          )}
        </>
      )}
    </>
  );
};

export default Home;
